module.exports = __webpack_public_path__ + "static/media/kailash-maharaj.2ac5948d.png";